import PlanejamentoAcaoFormAcoesFluxoNovo from '../../../produto/spa/planejamento-acao/form/PlanejamentoAcaoFormAcoesFluxoNovo';

export default PlanejamentoAcaoFormAcoesFluxoNovo;
